/* lua.js generated code undefined */
 // 关卡区间标签
let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
let TagConfig = require("clover/config/userTag/PersonalDifficultyTagConfig")
let Tag = xClass("PersonalDifficultyTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.record = table()
    UserLevel.getInstance().on(UserLevelEvent.StartLevel, handler(self, self.logStartLevel))
    UserLevel.getInstance().on(UserLevelEvent.WinLevel, handler(self, self.logWinLevel))
}
// 获取指定关卡（本机版本）的个人难度
Tag.prototype.getPersonalDiff = function (levelId) {
    let self = this
    let recordKey = self.getRecordKey(levelId)
    let diffRecord = self.record[recordKey]
    if (diffRecord) {
        if (diffRecord.success === 0) {
            return (diffRecord.challenge - 1) / 1
        } else {
            return (diffRecord.challenge - 1) / diffRecord.success
        }
    }
    return 0
}

Tag.prototype.getNature20Diff = function (levelId) {
    let self = this
    // cc.log("【掉落优化】计算20关自然难度")
    // DAManagerGUILogger.getInstance().print("【掉落优化】计算20关自然难度")
    let s = Math.max(1, tonumber(levelId) - 19)
    let e = tonumber(levelId)
    let sum = 0
    let $var33 = s,$limit34 = e
    let arr = UserTagData.getInstance().userLabelData.levelNatureDiff
    // for (let i = $var33; i <= $limit34; i += 1) {
    //     let lvId = tostring(i)
    //     sum = sum + (self._natureDiffCache[lvId] || 999)
    // }
    table.each(arr, function(diffRecord){
        if (diffRecord) {
            sum += diffRecord.natureDiff
            // if (diffRecord.passNum === 0) {
            //     diffSum = diffSum + (diffRecord.playNum - 1) / 1
            // } else {
            //     diffSum = diffSum + (diffRecord.playNum - 1) / diffRecord.passNum
            // }
        }
    })
    return sum
}
// 获取指定关卡（本机版本）及前20关的个人难度 只有新版本用
Tag.prototype.getPersonal20Diff = function () {
    let self = this
    // cc.log("【掉落优化】计算20关个人难度")
    // DAManagerGUILogger.getInstance().print("【掉落优化】计算20关个人难度")
    // let s = Math.max(1, tonumber(levelId) - 19)
    // let e = tonumber(levelId)
    // let successSum = 0
    // let diffSum = 0
    // let $var13 = s,$limit14 = e
    // for (let i = $var13; i <= $limit14; i += 1) {
    //     let recordKey = self.getRecordKey(i)
    //     let diffRecord = self.record[recordKey]
    //     if (diffRecord) {
    //         if (diffRecord.success === 0) {
    //             let diff = (diffRecord.challenge - 1) / 1
    //             diffSum = diffSum + diff
    //         } else {
    //             let diff = (diffRecord.challenge - 1) / diffRecord.success
    //             diffSum = diffSum + diff
    //         }
    //     }
    // }
    let diffSum = 0
    let arr = UserTagData.getInstance().userLabelData.levelPersonDiff
    table.each(arr, function(diffRecord){
        if (diffRecord) {
            if (diffRecord.passNum === 0) {
                diffSum = diffSum + (diffRecord.playNum - 0) / 1
            } else {
                diffSum = diffSum + (diffRecord.playNum - 0) / diffRecord.passNum
            }
        }
    })
    return diffSum
}
Tag.prototype.getRecordKey = function (levelId, version) {
    let self = this
    levelId = tostring(levelId)
    if (!version) {
        // H5关卡没有inf
        version = "";// he.ResManager.getInstance().getFileMd5("meta/level/" + levelId + ".inf")
        // if (__WIN32) {
        //     let Md5Helper = require("hecore/Md5Helper")
        //     version = Md5Helper.getInstance().calcMd5("meta/level/" + levelId + ".inf")
        // }
    }
    return levelId + "_" + version
}
Tag.prototype.logStartLevel = function (event) {
    // let self = this
    // let recordKey = self.getRecordKey(event.levelId)
    // if (self.record[recordKey]) {
    //     self.record[recordKey].challenge = self.record[recordKey].challenge + 1
    // } else {
    //     self.record[recordKey] = table([1, "success", 0], [1, "challenge", 1])
    // }
    // self.needStoreData()
}
Tag.prototype.logWinLevel = function (event) {
    // let self = this
    // let recordKey = self.getRecordKey(event.levelId)
    // if (self.record[recordKey]) {
    //     self.record[recordKey].success = self.record[recordKey].success + 1
    // } else {
    //     self.record[recordKey] = table([1, "success", 1], [1, "challenge", 1])
    // }
    // self.needStoreData()
}
Tag.prototype.convertOnlineRecord = function (data) {
    // let self = this
    // let record = table()
    // if (data.levelPersonDiff) {
    //     for (let levelId in data.levelPersonDiff) {
    //         let diffData = data.levelPersonDiff[levelId]
    //         if ($null(diffData)) continue
    //         let recordKey = self.getRecordKey(levelId, diffData.levelVer)
    //         record[recordKey] = table([1, "success", diffData.passNum], [1, "challenge", diffData.playNum])
    //     }
    // }
    // return table([1, "record", record])
}
Tag.prototype.refresh = function (data) {
    // let self = this
    // if (data.record) {
    //     self.record = data.record
    // }
}
// 202206掉落干预新增参数diffTagConfig：如果有此参数，下面的难度标签表用这个配置
Tag.prototype.getTag = function (levelId, diffTagConfig, formula_s, formula_e) {
    let self = this
    
    let testTagCfg = DAManager.getInstance().getTestTagCfg()
    let id = levelId && tonumber(levelId) || UserManager.getInstance().getPassedTopLevel()
    let pdiff = testTagCfg.personalDiff || UserTagData.getInstance().userLabelData.pDiff || 0; // self.getPersonalDiff(levelId)
    let ndiff = testTagCfg.natureDiff || UserTagData.getInstance().userLabelData.nDiff || 0; // DAManager.getInstance().getNatureDiff(levelId)
    UserManager.getInstance()._tmpPdiff = pdiff
    UserManager.getInstance()._tmpNdiff = ndiff
    let p20diff = testTagCfg.personal20Diff || self.getPersonal20Diff()
    let n20diff = testTagCfg.natureDiff || self.getNature20Diff(id)
    UserManager.getInstance()._tmpP20diff = p20diff
    UserManager.getInstance()._tmpN20diff = n20diff
    console.log("【掉落优化tag】--------- 计算难度标签【开始】---------");
    // DAManagerGUILogger.getInstance().print("--------- 计算难度标签【开始】---------")
    if (testTagCfg.personalDiff !== null) {
        console.log("覆盖个人难度");
        // DAManagerGUILogger.getInstance().print("覆盖个人难度")
    }
    if (testTagCfg.natureDiff !== null) {
        console.log("覆盖自然难度");
        // DAManagerGUILogger.getInstance().print("覆盖自然难度")
    }
    // console.log("当前个人难度：" + pdiff + ", 自然难度：" + ndiff);
    DAManagerGUILogger.getInstance().print("【掉落优化tag】当前个人难度p：" + pdiff + ", 自然难度n：" + ndiff)
    DAManagerGUILogger.getInstance().print("【掉落优化tag】当前20关个人难度p20：" + p20diff + ", 20关自然难度n20：" + n20diff)
    let config = UserTagData.getInstance().difftagConfig.configs; // MetaManager.getInstance().dropAdjustDiffTag.configs
    
    let tag_formula_s = 0
    let tag_formula_e = 3
    let formula_op = 1
    if (diffTagConfig) {
        config = diffTagConfig.configs
        if (formula_s) {
            tag_formula_s = formula_s
        }
        if (formula_e) {
            tag_formula_e = formula_e
        }
        if (formula_s > formula_e) {
            formula_op = -1
        }
        console.log("【掉落优化tag】  解析后的新难度配置表",config)
    }
    // console.log("【掉落优化】 PersonalDifficultyTag formula_op ",formula_op,tag_formula_s,tag_formula_e)
    
    let tag = 0
    for (let _ = 1, cfg = config[1]; cfg; _++, cfg = config[_]) {
        let startLevel = tonumber(cfg.startLevel)
        if (isNaN(startLevel)) {
            let expressionStr = cfg.startLevel.replace("max", UserManager.getInstance().getMaxLevelServer())
            // expressionStr = "return " + expressionStr
            // let f = loadstring(expressionStr)
            // if (f) {
            //     startLevel = f()
            // }
            let t = expressionStr.split("-");
            startLevel = t[0] - (t[1] || 0);
        }
        let endLevel = tonumber(cfg.endLevel)
        if (isNaN(endLevel)) {
            let expressionStr = cfg.endLevel.replace("max", UserManager.getInstance().getMaxLevelServer())
            // expressionStr = "return " + expressionStr
            // let f = loadstring(expressionStr)
            // if (f) {
            //     endLevel = f()
            // }
            let t = expressionStr.split("-");
            endLevel = t[0] - (t[1] || 0);
        }
        if (id >= startLevel && id <= endLevel) {
            console.log("【掉落优化tag】" + id + "处于关卡区间：[" + startLevel + ", " + endLevel + "]");
            // DAManagerGUILogger.getInstance().print(id + "处于关卡区间：[" + startLevel + ", " + endLevel + "]")
            let item 
            //新配置表新判断
            if (diffTagConfig){
                let index = (levelId - startLevel) % cfg.level_range + 1
                item = cfg["items"][index]
                console.log("【掉落优化tag】所属关卡号位置：" + index);
            }else {
                //旧配置表旧判断
                for (let i = 1, tmpitem = cfg.items[1]; tmpitem; i++, tmpitem = cfg.items[i]) {
                    // 先判断自然难度范围
                    let expressionStr = tmpitem.diff_range;
                    while(expressionStr.indexOf("n20") != -1){
                        expressionStr = expressionStr.replace("n20", "!")
                        expressionStr = expressionStr.replace("!", UserManager.getInstance()._tmpN20diff)
                    }
                    while(expressionStr.indexOf("n") != -1){
                        expressionStr = expressionStr.replace("n", "*")
                        expressionStr = expressionStr.replace("*", UserManager.getInstance()._tmpNdiff)
                    }
                    // console.log("【掉落优化】 expressionStr " , expressionStr);
                    // expressionStr = "return " + expressionStr
                    // let f = loadstring(expressionStr)
                    // if (f && f()) {
                    let f = loadExpression(expressionStr)
                    if (f){
                        console.log("【掉落优化tag】所属自然难度范围：" + tmpitem.diff_range);
                        item = tmpitem
                        break
                    }
                }
            }
                
            let $var56 = tag_formula_s,$limit57 = tag_formula_e,$step58 = formula_op
            for (let j = $var56; ($step58 > 0 && j <= $limit57) || ($step58 < 0 && j >= $limit57); j += $step58) {
                // console.log("【掉落优化】 item " , item, "tag_" + j + "_formula");
                let formula = item["tag_" + j + "_formula"]
                
                if (formula === "else") {
                    tag = j
                    console.log("【掉落优化tag】满足tag范围：" + "tag_" + j + "_formula");
                    // DAManagerGUILogger.getInstance().print("满足tag范围：" + "tag_" + j + "_formula")
                    break
                } else if (formula !== "" && formula !== null) {
                    while(formula.indexOf("n20") != -1 || formula.indexOf("p20") != -1){
                        formula = formula.replace("n20", "!")
                        formula = formula.replace("p20", "@")
                        formula = formula.replace("!", UserManager.getInstance()._tmpN20diff)
                        formula = formula.replace("@", UserManager.getInstance()._tmpP20diff)
                    }
                    while(formula.indexOf("n") != -1 || formula.indexOf("p") != -1){
                        formula = formula.replace("n", "*")
                        formula = formula.replace("p", "#")
                        formula = formula.replace("*", UserManager.getInstance()._tmpNdiff)
                        formula = formula.replace("#", UserManager.getInstance()._tmpPdiff)
                    }
        
                    // formula = "return " + formula
                    // let formulaFunc = loadstring(formula)
                    // if (formulaFunc && formulaFunc()) {
                    let formulaFunc = loadExpression(formula)
                    if (formulaFunc){
                        tag = j
                        console.log("【掉落优化tag】满足tag范围：" + "tag_" + j + "_formula");
                        // DAManagerGUILogger.getInstance().print("满足tag范围：" + "tag_" + j + "_formula")
                        break
                    }
                }
            }
            break
            // }
            // for (let i = 1, item = cfg.items[1]; item; i++, item = cfg.items[i]) {
            //     // 先判断自然难度范围
            //     let expressionStr = item.diff_range;
            //     while(expressionStr.indexOf("n20") != -1){
            //         expressionStr = expressionStr.replace("n20", "!")
            //         expressionStr = expressionStr.replace("!", UserManager.getInstance()._tmpN20diff)
            //     }
            //     while(expressionStr.indexOf("n") != -1){
            //         expressionStr = expressionStr.replace("n", "*")
            //         expressionStr = expressionStr.replace("*", UserManager.getInstance()._tmpNdiff)
            //     }
            //     console.log("【掉落优化】 expressionStr " , expressionStr);
            //     // expressionStr = "return " + expressionStr
            //     // let f = loadstring(expressionStr)
            //     // if (f && f()) {
            //     let f = loadExpression(expressionStr)
            //     if (f){
            //         console.log("【掉落优化】所属自然难度范围：" + item.diff_range);
            //         // DAManagerGUILogger.getInstance().print("所属自然难度范围：" + item.diff_range)
            //         let $var56 = tag_formula_s,$limit57 = tag_formula_e,$step58 = formula_op
            //         for (let j = $var56; ($step58 > 0 && j <= $limit57) || ($step58 < 0 && j >= $limit57); j += $step58) {
            //             let formula = item["tag_" + j + "_formula"]
            //             console.log("【掉落优化】 formula " , formula,"tag_" + j + "_formula");
            //             if (formula === "else") {
            //                 tag = j
            //                 console.log("【掉落优化】满足tag范围：" + "tag_" + j + "_formula");
            //                 // DAManagerGUILogger.getInstance().print("满足tag范围：" + "tag_" + j + "_formula")
            //                 break
            //             } else if (formula !== "" && formula !== null) {
            //                 while(formula.indexOf("n20") != -1 || formula.indexOf("p20") != -1){
            //                     formula = formula.replace("n20", "!")
            //                     formula = formula.replace("p20", "@")
            //                     formula = formula.replace("!", UserManager.getInstance()._tmpN20diff)
            //                     formula = formula.replace("@", UserManager.getInstance()._tmpP20diff)
            //                 }
            //                 while(formula.indexOf("n") != -1 || formula.indexOf("p") != -1){
            //                     formula = formula.replace("n", "*")
            //                     formula = formula.replace("p", "#")
            //                     formula = formula.replace("*", UserManager.getInstance()._tmpNdiff)
            //                     formula = formula.replace("#", UserManager.getInstance()._tmpPdiff)
            //                 }
              
            //                 // formula = "return " + formula
            //                 // let formulaFunc = loadstring(formula)
            //                 // if (formulaFunc && formulaFunc()) {
            //                 let formulaFunc = loadExpression(formula)
            //                 if (formulaFunc){
            //                     tag = j
            //                     console.log("【掉落优化】满足tag范围：" + "tag_" + j + "_formula");
            //                     // DAManagerGUILogger.getInstance().print("满足tag范围：" + "tag_" + j + "_formula")
            //                     break
            //                 }
            //             }
            //         }
            //         break
            //     }
            // }
            break
        }
    }
    DAManagerGUILogger.getInstance().print("【掉落优化tag】难度标签计算结果：" + tag)
    DAManagerGUILogger.getInstance().print("【掉落优化tag】--------- 计算难度标签【结束】---------")
    return tag
}
Tag.prototype.encode = function () {
    let self = this
    let data = table()
    data.record = self.record
    return data
}
module.exports = Tag
